export enum EInternalLinks {
	LINKEDIN = 'https://linkedin.com/company/contract-and-pay/',
	PRIVACY = 'https://contract-and-pay.com/privacy',
	PUBLIC = 'https://contract-and-pay.com/',
	TERMS_OF_USE = 'https://contract-and-pay.com/termsofuse/',
}
